module.exports = __webpack_public_path__ + "img/filter_off.2e0ae7d1.svg";